// extracted by mini-css-extract-plugin
module.exports = {"root":"Pagination_root__WUKJN","chevron":"Pagination_chevron__fyArL","useFade-fadeIn":"Pagination_useFade-fadeIn__KMZJM","useFade-fadeOut":"Pagination_useFade-fadeOut__h6Q9H"};